import { Box, Typography } from '@mui/material';
import React from 'react';
import Locale from 'src/Locale';
import * as core from 'cw-ui-core';

const AsioFailureStep = ({ data }) => {
  const state = core.Store().getState();
  const salesforceUrl = core.getModuleConfig(state.module, ['SalesForceCaseUrlBase']);
  const loggedInUserContactId = core.getModuleCache(state.module, ['user','crmContactId']);
  const caseId = data?.response?.id || data?.Id;
  const caseUrl = salesforceUrl + caseId;

  const renderText = (
    text,
    variant = 'paragraph',
    fontSize = '14px',
    marginBottom = '16px'
  ) => (
    <Typography
      variant={variant}
      fontSize={fontSize}
      pl="16px"
      marginBottom={marginBottom}
      fontWeight="400"
      color="#767786"
      lineHeight="18px"
      sx={{ fontFamily: 'sans-serif' }}

    >
      {core.formatMessage(text)}
    </Typography>
  );

  const caseNumber = data?.response?.number || data?.response?.caseNumber || data?.Number;
  const isCaseExists = data?.response?.errors === 'Case already exists';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Typography
        fontWeight={300}
        pl={2}
        fontSize={26}
        sx={{ fontFamily: 'sans-serif' }}
      >
        {core.formatMessage(Locale.asio_failure_step_title)}
      </Typography>
      <Typography
        fontWeight={300}
        pl={2}
        fontSize={26}
        sx={{ fontFamily: 'sans-serif' }}
      >
        {isCaseExists ? (
          <>
            {core.formatMessage(Locale.asio_failure_step_title2_Part1)}
            {data?.response?.contactId === loggedInUserContactId ? core.formatMessage(Locale.asio_failure_step_title2_Part2) : core.formatMessage(Locale.asio_failure_step_title2_Part4, { contactName: data?.response?.contactName })}
            <a
              href={caseUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              {core.formatMessage(Locale.asio_failure_step_title2_Part3, { caseNumber })}
            </a>
          </>
        ) : (
          core.formatMessage(Locale.asio_failure_step_title2, { caseNumber })
        )}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            pr: '8px',
            mt: '64px',
            width: '55%',
          }}
        >
          {renderText(Locale.asio_failure_step_sub)}
          {renderText(Locale.asio_failure_step_sub2)}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            width: '45%',
            alignItems: 'center',
            pl: '8px',
          }}
        >
          <Box
            component="img"
            src="/images/AsioPage/DialogError.png"
            sx={{
              width: '90%',
              height: '70%',
              objectFit: 'contain',
            }}
            alt="Error"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AsioFailureStep;
